const SYNC_ENTITY_LABEL: Record<string, string> = {
  department: "khoa",
  room: "phòng",
  service: "dịch vụ",
  province: "tỉnh/thành",
  ward: "phường/xã",
};

const SYNC_REASON_LABEL: Record<string, string> = {
  no_result_payload: "HIS không trả dữ liệu — thường do địa chỉ máy chủ (base URL) sai đường dẫn",
  not_configured: "chưa khai đủ địa chỉ máy chủ hoặc khoá kết nối",
};

/**
 * #19086 — `failureReason` is `entity=code, …` (e.g. `department=no_result_payload,
 * province=no_result_payload`). Group by reason and say it in Vietnamese; an unknown code is shown
 * as-is so nothing is hidden.
 */
export function describeSyncFailure(reason: string | null | undefined): string {
  if (!reason) return "không rõ";
  const byReason = new Map<string, string[]>();
  for (const part of reason.split(",")) {
    const [entity, code] = part.trim().split("=");
    if (!entity) continue;
    const key = code ?? entity;
    const label = code ? (SYNC_ENTITY_LABEL[entity] ?? entity) : null;
    const list = byReason.get(key) ?? [];
    if (label && !list.includes(label)) list.push(label);
    byReason.set(key, list);
  }
  return [...byReason.entries()]
    .map(([code, entities]) => {
      const why = SYNC_REASON_LABEL[code] ?? code;
      return entities.length ? `${entities.join(", ")}: ${why}` : why;
    })
    .join("; ");
}
